<template>
  <page-header-wrapper>
    <a-card>
      <div class="table-page-search-wrapper">
        <a-form layout="inline" class="table-head-ground">
          <div class="table-layer">
            <!-- 用户id -->
            <!-- <a-form-item label="">
              <jeepay-text-up
                :placeholder="'用户ID'"
                :msg="searchData.userId"
                v-model="searchData.userId"
              />
            </a-form-item> -->
            <a-form-item label="">
              <jeepay-text-up
                :placeholder="'用户名'"
                :msg="searchData.userName"
                v-model="searchData.userName"
              />
            </a-form-item>
            <!-- <a-form-item label="">
              <a-select v-model="searchData.sysType" placeholder="运营平台" default-value="" style="width: 150px">
                <a-select-option
                  v-for="option in EXPORT_SYS_TYPE_OPTIONS"
                  :key="option.value"
                  :value="option.value"
                >
                  {{ option.label }}
                </a-select-option>
              </a-select>
            </a-form-item> -->
            <a-form-item label="">
              <a-select v-model="searchData.bizType" placeholder="业务类型" default-value="" style="width: 150px">
                <a-select-option
                  v-for="option in EXPORT_BIZ_TYPE_OPTIONS"
                  :key="option.value"
                  :value="option.value"
                >
                  {{ option.label }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <!-- 商户号 -->
            <!-- <a-form-item label="">
              <jeepay-text-up
                :placeholder="'商户号'"
                :msg="searchData.mchNo"
                v-model="searchData.mchNo"
              />
            </a-form-item> -->
            <a-form-item label="" >
              <jeepay-text-up
                :placeholder="'文件名'"
                :msg="searchData.fileName"
                v-model="searchData.fileName"
              />
            </a-form-item>
            <a-form-item label="">
              <a-select v-model="searchData.status" placeholder="状态" default-value="" style="width: 150px">
                <a-select-option
                  v-for="option in EXPORT_STATUS_OPTIONS"
                  :key="option.value"
                  :value="option.value"
                >
                  {{ option.label }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" icon="search" @click="queryFunc" :loading="btnLoading">查询</a-button>
                <a-button style="margin-left: 8px" icon="reload" @click="resetForm">重置</a-button>
              </span>
            </a-form-item>

          </div>
        </a-form>
      </div>

      <!-- 列表渲染 -->
      <JeepayTable
        @btnLoadClose="btnLoading=false"
        ref="infoTable"
        :initData="true"
        :reqTableDataFunc="reqTableDataFunc"
        :tableColumns="tableColumns"
        :searchData="searchData"
        rowKey="id"
      >
        <template slot="sysTypeSlot" slot-scope="{record}">
          {{ getExportSysTypeText(record.sysType) }}
        </template>
        <template slot="bizTypeSlot" slot-scope="{record}">
          {{ getExportBizTypeText(record.bizType) }}
        </template>
        <template slot="fileUrlSlot" slot-scope="{record}">
          <a-tag :color="getExportStatusColor(record.status)">
            {{ getExportStatusText(record.status) }}
          </a-tag>
        </template>
        <template slot="createdAtSlot" slot-scope="{record}">
          {{ formatTimestamp(record.createdAt) }}
        </template>
      </JeepayTable>
    </a-card>

    <!-- 导出记录模态框 -->
    <a-modal
      :visible="exportRecordVisible"
      title="导出记录"
      @cancel="exportRecordVisible = false"
      :footer="null"
      width="900px"
      :destroyOnClose="true"
    >
      <a-table
        :columns="exportRecordColumns"
        :dataSource="exportRecordData"
        :loading="exportRecordLoading"
        :pagination="false"
        rowKey="id"
        size="small"
      >
        <template slot="statusSlot" slot-scope="{record}">
          <a-tag :color="getExportStatusColor(record.status)">
            {{ getExportStatusText(record.status) }}
          </a-tag>
        </template>
        <template slot="createdAtSlot" slot-scope="{record}">
          {{ formatTimestamp(record.createdAt) }}
        </template>
        <template slot="actionSlot" slot-scope="{record}">
          <a-button
            v-if="record.ossAddress && record.status === 1"
            type="link"
            icon="download"
            @click="downloadFile(record.ossAddress, record.fileName)"
          >
            下载
          </a-button>
          <span v-else>--</span>
        </template>
      </a-table>
    </a-modal>
  </page-header-wrapper>
</template>

<script>
import { tableColumns } from './tableColumn'
import JeepayTable from '@/components/JeepayTable/JeepayTable'
import JeepayTextUp from '@/components/JeepayTextUp/JeepayTextUp'
import JeepayTableColumns from '@/components/JeepayTable/JeepayTableColumns'
import { getExportList } from '@/api/export'
import { uploadOrderExcel, getOrderExportList } from '@/api/manage'
import {
  getExportSysTypeText,
  getExportBizTypeText,
  getExportStatusText,
  getExportStatusColor,
  EXPORT_SYS_TYPE_OPTIONS,
  EXPORT_BIZ_TYPE_OPTIONS,
  EXPORT_STATUS_OPTIONS
} from '@/utils/constants'
import { formatTimestamp } from '@/utils/util'

// 导出记录表格列定义
const exportRecordColumns = [
  {
    title: '创建时间',
    key: 'createdAt',
    width: 180,
    scopedSlots: { customRender: 'createdAtSlot' }
  },
  {
    title: '状态',
    key: 'status',
    width: 100,
    scopedSlots: { customRender: 'statusSlot' }
  },
  {
    title: '文件名',
    dataIndex: 'fileName',
    key: 'fileName',
    width: 200
  },
  {
    title: '操作',
    key: 'action',
    width: 100,
    align: 'center',
    scopedSlots: { customRender: 'actionSlot' }
  }
]

export default {
  name: 'ExportListPage',
  components: {
    JeepayTable,
    JeepayTextUp,
    JeepayTableColumns
  },
  data () {
    return {
      btnLoading: false,
      exportLoading: false,
      tableColumns: tableColumns,
      searchData: {},
      // 从constants导入的选项数组
      EXPORT_SYS_TYPE_OPTIONS,
      EXPORT_BIZ_TYPE_OPTIONS,
      EXPORT_STATUS_OPTIONS,
      // 导出记录相关
      exportRecordVisible: false,
      exportRecordLoading: false,
      exportRecordData: [],
      exportRecordColumns: exportRecordColumns
    }
  },
  methods: {
    // 查询按钮点击事件
    queryFunc () {
      this.btnLoading = true
      this.$refs.infoTable.refTable(true)
    },

    // 请求table接口数据
    reqTableDataFunc: (params) => {
      return getExportList(params)
    },

    // 重置表单
    resetForm () {
      this.searchData = {}
      this.$nextTick(() => {
        this.queryFunc()
      })
    },

    // 导出功能
    exportFunc () {
      this.exportLoading = true
      // 使用当前搜索条件作为导出参数
      uploadOrderExcel(this.searchData).then(res => {
        this.$message.success('导出请求已提交，请在导出记录中查看进度')
        this.exportLoading = false
      }).catch(err => {
        console.error('导出失败:', err)
        this.$message.error('导出失败')
        this.exportLoading = false
      })
    },

    // 显示导出记录
    showExportRecords () {
      this.exportRecordVisible = true
      this.loadExportRecords()
    },

    // 加载导出记录
    loadExportRecords () {
      this.exportRecordLoading = true
      getOrderExportList().then(res => {
        this.exportRecordData = res || []
        this.exportRecordLoading = false
      }).catch(err => {
        console.error('获取导出记录失败:', err)
        this.$message.error('获取导出记录失败')
        this.exportRecordLoading = false
      })
    },

    // 下载文件
    downloadFile (url, fileName) {
      const link = document.createElement('a')
      link.href = url
      link.download = fileName || '导出文件'
      link.target = '_blank'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },

    // 导入公共方法
    getExportSysTypeText,
    getExportBizTypeText,
    getExportStatusText,
    getExportStatusColor,
    formatTimestamp
  },

  mounted () {
    // 组件挂载后自动查询
    this.queryFunc()
  }
}
</script>

<style scoped>
.table-page-search-wrapper {
  margin-bottom: 16px;
}

.table-head-ground {
  /* padding: 16px; */
  background: #fafafa;
  border-radius: 6px;
  padding-bottom: 30px;
}

.table-layer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px;
}

.table-head-layout {
  margin-right: 16px;
  margin-bottom: 16px;
}

.table-page-search-submitButtons {
  display: flex;
  gap: 8px;
}

.mg-b-30 {
  margin-bottom: 30px;
}
</style>
